export default __webpack_public_path__ + "static/media/15.40ec0e32.gif";